// extracted by mini-css-extract-plugin
export var details = "Person-module--details--24708";
export var image = "Person-module--image--bb5ed";
export var roundedImage = "Person-module--roundedImage--29c27";
export var wrapper = "Person-module--wrapper--a0500";